import React, { Component } from 'react';
import { Button } from 'react-bootstrap';
import Header from '../../../components/Header/Header';

// Import Style
import '../style.scss';

import logo from '../../../assets/img/nave-logo.svg';

class ErrorPage extends Component {

  login() {
    global.window &&
      window.location &&
      window.location.replace('/login');
  }

  render() {
    return (
      <div className='azure-error'>
        <Header showHome={true} />
        <div className='content'>
          <h1 className='text-center'>There was a problem signing you in!</h1>
          <h3 className='text-center'>To resolve the issue, try the following steps:</h3>
          <div className='azure-steps'>
            <div className='azure-step-item'>
              <div className='azure-step-number'>1</div>
              <p>
                Open your browser in Incognito Mode, log in to Azure DevOps with your corporate account, then log in to Nave.
              </p>
            </div>
            <div className='azure-step-item'>
              <div className='azure-step-number'>2</div>
              <p>
                If you use Active Directory, please make sure your user is a member of AD. 
                If you are a guest, Azure API won't enable you to go through the authentication process. 
                A must-have prerequisite to signing in to Nave is that your user is an AD member .
              </p>
            </div>
            <div className='azure-step-item'>
              <div className='azure-step-number'>3</div>
              <p>
                Make sure you've enabled Third-party application access via the OAuth option in your Organization Settings → Policies so that Nave can establish a connection to your Azure instance.
              </p>
            </div>
            <div className='azure-step-item'>
              <div className='azure-step-number'>4</div>
              <p>
                In none of the above works, please contact us via email at <a href='mailto:hello@getnave.com'>hello@getnave.com</a> and we'll take it from there.
              </p>
            </div>
          </div>
          
          <div className='action-button'>
            <Button variant='primary' onClick={this.login}>
              Back to Login
            </Button>
          </div>
        </div>
      </div>
    );
  }
}

export default ErrorPage;
